import { ISwitchOptions, Switch } from "devextreme-react/switch";
import { useState } from "react";
import "./styles/Controls.css";

interface Props {
  onCaption: string;
  offCaption: string;
  onValueChange?: (evt: boolean) => void;
}

export default function PromineoSwitch(props: Props & ISwitchOptions) {
  const { onCaption, offCaption, className, onValueChange, ...rest } = props;
  const [isOn, setIsOn] = useState(rest.defaultValue);

  const getCaption = (text: string, isOn: boolean, isCaptionForOff: boolean) => {
    return (
      <span
        className={`text-sm ${isOn ? "black" : "text-promGray2"} ${
          isCaptionForOff ? "mr-1" : "ml-1"
        }`}
      >
        {text}
      </span>
    );
  };

  const handleValueChanged = (isOn: boolean) => {
    setIsOn(isOn);
    onValueChange?.(isOn);
  };

  return (
    // We do not want to display on / off text inside the switch, that's why we need to set switchedOnText and switchedOffText as empty.
    <>
      {offCaption && getCaption(offCaption, !isOn, true)}
      <Switch
        switchedOnText=""
        switchedOffText=""
        {...rest}
        onValueChange={handleValueChanged}
        className={`promineo-switch ${className}`}
      />
      {onCaption && getCaption(onCaption, isOn, false)}
    </>
  );
}
